<script setup lang="ts">
import { computed } from 'vue'
import { riskConfig } from './riskConfig'
import { formatAxisLevel } from './shared'

const props = defineProps<{
	probability?: number
	impact?: number
}>()

const probabilityLevel = computed(() => {
	if (props.probability !== undefined) {
		const i = formatAxisLevel(props.probability!)
		if (i < riskConfig.value.riskProbabilities.length) return riskConfig.value.riskProbabilities[i]
	}
	return undefined
})

const impactLevel = computed(() => {
	if (props.impact !== undefined) {
		const i = formatAxisLevel(props.impact!)
		if (i < riskConfig.value.riskImpacts.length) return riskConfig.value.riskImpacts[i]
	}
	return undefined
})

const riskLevel = computed(() => {
	let i = 0
	if (props.probability !== undefined) i = formatAxisLevel(props.probability)
	else if (props.impact !== undefined) i = formatAxisLevel(props.impact)
	else return

	return i < riskConfig.value.riskLevels.length
		? riskConfig.value.riskLevels[i]
		: {
				color: 'transparent',
			}
})
</script>

<template>
	<div class="text-nowrap" v-one-tooltip="probabilityLevel ? probabilityLevel.description : impactLevel?.description">
		<i v-if="riskLevel" class="bi bi-circle-fill" :style="'color: ' + riskLevel.color"></i>&nbsp;
		<span v-if="probabilityLevel && props.probability !== undefined"
			>{{ formatAxisLevel(props.probability) + 1 }} {{ probabilityLevel.title }}</span
		>
		<span v-else-if="impactLevel && props.impact !== undefined">{{ formatAxisLevel(props.impact) + 1 }} {{ impactLevel.title }}</span>
	</div>
</template>
